import PropositionEntity, { PropositionJSON } from '../entities/Proposition';
import PropositionsGroupEntity, { PropositionsGroupJSON, PropositionsGroupType } from '../entities/PropositionsGroup';
import { formatAddress, getCityAndCountry, getTimezone } from './addresses';
import { formatDate } from './dates';

export function isPropositionsGroupDraft({ status }: Pick<PropositionsGroupEntity, 'status'>): boolean {
  return status === 'DRAFT';
}

export function isPropositionsGroupOpen({ status }: Pick<PropositionsGroupEntity, 'status'>): boolean {
  return status === 'OPEN';
}

export function isPropositionsGroupClosed({ status }: Pick<PropositionsGroupEntity, 'status'>): boolean {
  return status === 'CLOSED';
}

export function hasAPropositionsGroupOpen(propositionsGroups: (PropositionsGroupEntity | PropositionsGroupJSON)[]) {
  return propositionsGroups.some(isPropositionsGroupOpen);
}

export function getPropositionsByPropositionsGroupId<P extends PropositionEntity | PropositionJSON>(propositions: P[], propositionsGroupId: PropositionsGroupEntity['id']) {
  return propositions.filter(proposition =>
    proposition.propositionsGroupId === propositionsGroupId
  );
}

export function hasAPropositionsGroupWaitingPropososals(propositionsGroups: (PropositionsGroupEntity | PropositionsGroupJSON)[], propositions: (PropositionEntity | PropositionJSON)[]) {
  return propositionsGroups.some(propositionsGroup => {
    const filteredPropositions = getPropositionsByPropositionsGroupId(propositions, propositionsGroup.id);

    if (isPropositionsGroupClosed(propositionsGroup)) {
      return false;
    }

    if (isPropositionsGroupOpen(propositionsGroup)) {
      return filteredPropositions.length > 0 && filteredPropositions.every(({ declinedAt }) => !!declinedAt);
    }

    return true;
  });
}

export function isPropositionsGroupType(type: string): type is PropositionsGroupType {
  return ['CUSTOM_REQUEST', 'SPECIFIC_PARTNER', 'PAY_VIA_JURNEE'].includes(type as PropositionsGroupType);
}

export function getLocationProps(propositionsGroup: PropositionsGroupJSON) {
  if (propositionsGroup.address) {
    return {
      value: getCityAndCountry(propositionsGroup.address)
    };
  }

  if (propositionsGroup.office) {
    return {
      value: propositionsGroup.office.name,
      tooltip: formatAddress(propositionsGroup.office.address)
    };
  }

  return {
    value: '-'
  };
}

export function getFormattedFromDate(propositionsGroup: PropositionsGroupJSON) {
  if (!propositionsGroup.from) {
    return null;
  }

  const timeZone = getTimezone(propositionsGroup);

  return formatDate(new Date(propositionsGroup.from),{
    displayTime: true,
    displayTimeZone: true,
    timeZone
  });
}